import { render, staticRenderFns } from "./WorkspaceObjectItem.vue?vue&type=template&id=dec4b2a4&scoped=true&"
import script from "./WorkspaceObjectItem.vue?vue&type=script&lang=ts&"
export * from "./WorkspaceObjectItem.vue?vue&type=script&lang=ts&"
import style0 from "./WorkspaceObjectItem.vue?vue&type=style&index=0&id=dec4b2a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec4b2a4",
  null
  
)

export default component.exports